module.exports = __webpack_public_path__ + "img/n8.7bc0830c.png";